import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { productService } from '../../services/product.service';
import { Loader2 } from 'lucide-react';

interface CategoryFilterProps {
  selectedCategory: string;
  onSelect: (slug: string) => void;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({ selectedCategory, onSelect }) => {
  const { data: categories, isLoading } = useQuery({
    queryKey: ['product-categories'],
    queryFn: productService.getCategories,
  });

  if (isLoading) {
    return <Loader2 className="h-4 w-4 animate-spin text-primary" />;
  }

  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={() => onSelect('')}
        className={`rounded-full px-3 py-1 text-sm transition-all ${
          !selectedCategory
            ? 'bg-primary text-white'
            : 'border border-[rgb(var(--border))] text-[rgb(var(--foreground))] hover:bg-[rgb(var(--border))]'
        }`}
      >
        All
      </button>
      {categories?.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.slug)}
          className={`rounded-full px-3 py-1 text-sm transition-all ${
            selectedCategory === cat.slug
              ? 'bg-primary text-white'
              : 'border border-[rgb(var(--border))] text-[rgb(var(--foreground))] hover:bg-[rgb(var(--border))]'
          }`}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
};